"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getHandleGxV1Done = exports.getHandleGxDone = exports.getHandleGxChange = void 0;
var _gx = require("@kyruus/gx");
var _Tracking = require("../../lib/constants/Tracking");
var _Actions = require("../../lib/constants/Actions");
/**
 * Handles what happens when we're done with a GX v1 flow.
 * This means the the flow passed or failed.
 * We update the machine and tracking info based on that state.
 *
 * Note: After a GX v1 flow has been completed with answers from a user,
 * any user change to an answer will call the `onDone` handler instead of the `onChange` handler.
 *
 * @param {Object} props
 * @param {function} props.send  machine `send` function
 * @param {function} props.track  tracking function
 * @returns {function} return onDone handler function
 */
const getHandleGxV1Done = _ref => {
  let {
    send,
    track
  } = _ref;
  return _ref2 => {
    let {
      name,
      ctx,
      curState,
      trackingData
    } = _ref2;
    if (curState === _gx.constants.states.doneLeft) {
      track(_Tracking.userEvents.GX_QUESTION_ANSWER, {
        ...trackingData,
        status: _gx.constants.trackingStatuses.FAIL,
        flow_name: name
      });
      send({
        type: _Actions.GX_V1_FAILED,
        data: ctx
      });
    }
    if (curState === _gx.constants.states.doneRight) {
      track(_Tracking.userEvents.GX_QUESTION_ANSWER, {
        ...trackingData,
        status: _gx.constants.trackingStatuses.SUCCESS,
        flow_name: name
      });
      send({
        type: _Actions.GX_PASSED,
        data: ctx
      });
    }
  };
};

/**
 * Handles what happens when we're done with a GX v2 flow and the Gx question set has passed, failed, or errored.
 * We update the tracking info based on the state,
 * and conditionally update the state machine.
 *
 * @param {Object} props
 * @param {function} props.send  machine `send` function
 * @param {function} props.track  tracking function
 * @param {string} props.event  UI event to be fired conditionally
 * @returns {function} return onDone handler function
 */
exports.getHandleGxV1Done = getHandleGxV1Done;
const getHandleGxDone = _ref3 => {
  let {
    send,
    track,
    event
  } = _ref3;
  return _ref4 => {
    let {
      name,
      ctx,
      curState,
      trackingData
    } = _ref4;
    const mapStateToTrackingStatus = {
      [_gx.constants.states.error]: _gx.constants.trackingStatuses.ERROR,
      [_gx.constants.states.warning]: _gx.constants.trackingStatuses.FAIL,
      [_gx.constants.states.done]: _gx.constants.trackingStatuses.SUCCESS,
      [_gx.constants.states.skipped]: _gx.constants.trackingStatuses.SUCCESS
    };
    track(_Tracking.userEvents.GX_QUESTION_ANSWER, {
      ...trackingData,
      status: mapStateToTrackingStatus[curState],
      flow_name: name
    });
    if (curState === _gx.constants.states.done || curState === _gx.constants.states.skipped) {
      send({
        type: event,
        data: ctx
      });
    }
  };
};

/**
 * Handles what happens when a user has answered a question from a GX question set.
 *
 * - This isn't necessarily a `change/blur` event. e.g:
 *  For a DOB input, an answer would only make it through if it was valid.
 *  Meaning the user has entered a valid date in the input.
 *
 * - We track only if there aren't any errors.
 *
 * @param {Object} props
 * @param {function} props.send  machine `send` function
 * @param {function} props.track  tracking function
 * @param {string} props.event  UI event to be fired on done
 * @returns {function} return change handler function
 */
exports.getHandleGxDone = getHandleGxDone;
const getHandleGxChange = _ref5 => {
  let {
    send,
    track,
    event
  } = _ref5;
  return _ref6 => {
    let {
      name,
      errors = [],
      trackingData
    } = _ref6;
    // we send an `answered` event even when there are errors
    // to adjust to the correct state from "answered" to "answer has changed"
    send(event);
    if (errors.length === 0) {
      track(_Tracking.userEvents.GX_QUESTION_ANSWER, {
        ...trackingData,
        flow_name: name,
        status: _gx.constants.trackingStatuses.INCOMPLETE
      });
    }
  };
};
exports.getHandleGxChange = getHandleGxChange;